import { useRSStore } from '../store/useRSStore'
import { readPriorityListAPI ,addPriorityAPI, updatePriorityAPI, deletePriorityAPI, paginationPriorityAPI} from '../api/PriorityAPI'

import type { priority, addpriority, pagination } from '../types/types'


export function usePriority() {
  const RSStore = useRSStore()
  const onReadPriorityList = async (pagination: pagination) => {
    try {
      const list = await readPriorityListAPI(pagination)
      RSStore.priorityList = list
    } catch (e) {
      console.error("priority 데이터를 가져오는 중 에러 발생:", e)
    }
  }

  const onAddPriority = async (addpriority: addpriority) => {
    try {
      const result = await addPriorityAPI(addpriority)
      console.log("priority 추가 완료 id:", result)
    } catch (e) {
      console.error("priority 추가 중 에러 발생:", e)
    }
  }

  const onUpdatePriority = async (priority: priority) => {
    try {
      const result = await updatePriorityAPI(priority)
      if (result) {
      console.log("priority 업데이트 완료 :", priority)
      } else {
        console.log("priority 업데이트 실패 입력값 확인 필요", priority)
      }
    } catch (e) {
      console.error("priority 업데이트 중 에러 발생:", e)
    }
  }

  const onDeletePriority = async (id: number) => {
    try {
      const result = await deletePriorityAPI(id)
      if (result) {
        console.log("priority 삭제 완료 id:", id)
      } else {
        console.log("priority 삭제 실패 id:", id)
      }
    } catch (e) {
      console.error("priority 삭제 중 에러 발생:", e)
    }
  } 

  const onPaginationPriority = async (size: number) => {
    try {
      const result = await paginationPriorityAPI(size) ?? 0
      return result
    } catch (e) {
      console.error("priority pagination 가져오는 중 에러 발생:", e)
    }
  }
  return {
    onReadPriorityList,
    onAddPriority,
    onUpdatePriority,
    onDeletePriority,
    onPaginationPriority
  }
}